import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Header from './components/Header';
import ConstellationBackground from './components/ConstellationBackground';
import Home from './pages/Home';
import Register from './pages/Register';
import Login from './pages/Login';
import Freelancers from './pages/Freelancers';
import FreelancerProfile from './pages/FreelancerProfile';
import PostProject from './pages/PostProject';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import EditProfile from './pages/EditProfile';
import ClientProfile from './pages/ClientProfile';
import ClientProjects from './pages/ClientProjects';
import MyFreelancerProfile from './pages/MyFreelancerProfile';
import './index.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App min-h-screen relative text-white">
          {/* Global Dark Background */}
          <ConstellationBackground />
          
          {/* Header */}
          <Header />
          
          {/* Main Content with proper padding below header and global typography */}
          <main className="relative z-10 pt-20 text-white">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/register" element={<Register />} />
              <Route path="/login" element={<Login />} />
              <Route path="/freelancers" element={<Freelancers />} />
              <Route path="/freelancer/:id" element={<FreelancerProfile />} />
              <Route path="/post-project" element={<PostProject />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/project/:id" element={<ProjectDetail />} />
              <Route path="/edit-profile" element={<EditProfile />} />
              <Route path="/client-profile" element={<ClientProfile />} />
              <Route path="/client-projects" element={<ClientProjects />} />
              <Route path="/freelancer-profile" element={<MyFreelancerProfile />} />
            </Routes>
          </main>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App; 